import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import * as reducers from "./ducks";
import { apiService, createLogger } from "./middleware";

export default function configureStore(initialState) {
    const rootReducer = combineReducers(reducers);

    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(apiService, thunk, createLogger(false))
    );
}



// WEBPACK FOOTER //
// ./store.js